import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Importer } from '@feathr/blackbox';
import { Text } from '@feathr/components';

import { hasRunStarted } from './ImportRunDetails.utils';

interface INotStartedLineProps {
  importer: Importer;
}

/**
 * Says why a draft or a queued import has no run details yet. Nothing once the run has started,
 * and nothing for a failed import, whose failure reason says what happened.
 */
function NotStartedLine({ importer }: Readonly<INotStartedLineProps>): JSX.Element | null {
  const { t } = useTranslation();

  const state = importer.get('state');
  if (state === 'draft') {
    // Placeholder copy, pending Product and Design (decision 23).
    return <Text.DefaultRegular>{t("This import hasn't been submitted yet.")}</Text.DefaultRegular>;
  }
  if (state === 'pending' && !hasRunStarted(importer)) {
    // Placeholder copy, pending Product and Design (decision 23).
    return <Text.DefaultRegular>{t('This import is waiting to start.')}</Text.DefaultRegular>;
  }
  return null;
}

export default observer(NotStartedLine);
